import { render, staticRenderFns } from "./PEBackground.vue?vue&type=template&id=2ac41485&scoped=true&"
import script from "./PEBackground.vue?vue&type=script&lang=js&"
export * from "./PEBackground.vue?vue&type=script&lang=js&"
import style0 from "./PEBackground.vue?vue&type=style&index=0&id=2ac41485&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac41485",
  null
  
)

export default component.exports